// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Switch, Select, Button, Badge, InputNumber, Checkbox, ConfigProvider, Radio, Tooltip, Tree, Tag } from 'antd';
import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import styles from './styles.module.css'
import { Tabs } from 'antd';
import { FaCheck } from "react-icons/fa6";



const ViewSupport = ({ modalVisible, closeModal, selSupportInput, submitFeedback }) => {
    const handleCancel = () => {
        closeModal();
        setSelectedSupport(null);
        setSupportTicketFromSameBooking(null);
        setSelSupportBtnInput(null);
        setUpdateIssueForm({ status: null, imageVerified: false, refund: false, refundAmount: 0 });
    };
    const [isLoading, setIsLoading] = useState(false);
    const [selSupport, setSelectedSupport] = useState(null);
    const [supportTicketFromSameBooking, setSupportTicketFromSameBooking] = useState(null);
    const [selSupportBtnInput, setSelSupportBtnInput] = useState(null);
    const [sendEmailToUser, setSendEmailToUser] = useState(false)

    const [isAnyTicketRefunded, setIsAnyTicketRefunded] = useState(null);


    const [submitting, setSubmitting] = useState(false);
    const [updateIssueForm, setUpdateIssueForm] = useState({ status: null, imageVerified: false, refund: false, refundAmount: 0, bookingStatus: '' });
    const handleUpdateIssueFormChange = (field, value) => {
        setUpdateIssueForm(updateIssueForm => ({ ...updateIssueForm, [field]: value }));

    };


    const formatDate = (dateString) => {
        const dateToConvert = new Date(dateString);
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };
        let updatedFormat = dateToConvert.toLocaleTimeString(undefined, options);
        return updatedFormat;
    }


    const getSupport = async () => {

        setIsLoading(true);
        const result = await BreathAPIs.getSupport(selSupportBtnInput ? selSupportBtnInput : selSupportInput?._id);
        setSelectedSupport(result?.data?.supportTicket);
        setSupportTicketFromSameBooking(result?.data?.supportTicketFromSameBooking);
        handleUpdateIssueFormChange('status', result.data?.supportTicket?.status);
        handleUpdateIssueFormChange('imageVerified', result.data?.supportTicket?.imageVerified);
        setIsLoading(false);

        const refundedTicket = result?.data?.supportTicketFromSameBooking?.find(ticket => ticket.refundStatus === true);
        setIsAnyTicketRefunded(refundedTicket);

        // const refundAmount = result.data?.prevBooking?.totalCost;
        const refundAmount = ((result?.data?.supportTicket?.prevBooking?.totalCost) ? result?.data?.supportTicket?.prevBooking?.totalCost : result?.data?.supportTicket?.prevBooking?.estimateAmount);
        handleUpdateIssueFormChange('refundAmount', refundAmount?.toFixed(2));

    }

    const updateSupport = async () => {

        if (updateIssueForm.refund === true && !updateIssueForm.refundAmount) {
            toast.error('Please enter a valid amount');
            return;
        }

        setSubmitting(true);
        const response = await BreathAPIs.updateSupport(
            {
                status: updateIssueForm.status,
                imageVerified: updateIssueForm.imageVerified,
                refund: updateIssueForm.refund,
                refundAmount: updateIssueForm.refundAmount,
                bookingStatus: selSupport?.prevBooking?.bookingStatus,
                sendEmailToUser: sendEmailToUser
            },
            selSupportBtnInput ? selSupportBtnInput : selSupportInput?._id

        );
        setSubmitting(false);
        toast.success(response.data.message);
        getSupport();
        submitFeedback();
    }

    useEffect(() => {
        if (selSupportInput && modalVisible) {
            getSupport();
        }
    }, [selSupportInput, selSupportBtnInput]);


    function normalizeString(str) {
        return str
            .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
            .replace(/^./, char => char.toUpperCase());  // Capitalize the first letter
    }
    const convertToTreeData = (data, parentKey = '') => {
        return Object.entries(data).map(([key, value]) => {
            const currentKey = parentKey ? `${parentKey}-${key}` : key;

            if (typeof value === 'object' && value !== null) {
                return {
                    title: value?.action ?  value?.action : normalizeString(key),
                    key: currentKey,
                    children: convertToTreeData(value, currentKey),
                };
            } else {
                return {
                    title: `${normalizeString(key)}: ${key == 'logDate' ? formatDate(value) : ( (key == 'currentEnergyMeterValue' || key == 'previousEnergyMeterValue') ? value.toFixed(4) : value)}`,
                    key: currentKey,
                };
            }
        });
    };
    const jsonData = selSupport?.logs ? JSON.parse(selSupport.logs) : [];
    const treeData = jsonData ? convertToTreeData(jsonData) : [];


    const items = [
        {
            key: '1',
            label: 'Basic',
            children:
                <>

                    <div className={styles['view-top']}>
                        <div>ID <b>{selSupport?._id}</b></div>
                        {selSupport?.userID?.isGuest && <div>User Type <Tag color="gold">Guest</Tag></div>}
                        <div>Support Ref ID <b>{selSupport?.supportRef ? selSupport?.supportRef : 'NULL'}</b></div>
                        <div>Issue Type <b>{selSupport?.mainIssueType}</b></div>
                        {selSupport?.issueType && <div>Issue <b>{selSupport?.issueType}</b></div>}
                        {selSupport?.description && <div>Description <b>{selSupport?.description}</b></div>}
                        {selSupport?.image &&
                            <div className={styles['image-container']}>Image
                                <img style={{ Width: '100%' }} src={selSupport?.image} />
                            </div>
                        }
                        {selSupport?.imageVerified && <div>Image Verified <b>{selSupport?.imageVerified ? <Badge size='small' count={'Verified'} color='#3d9014' /> : 'No'}</b></div>}
                        {selSupport?.plateNumber && <div>Plate Number <b>{selSupport?.plateNumber}</b></div>}
                        <div>Date <b>{formatDate(selSupport?.date)}</b></div>
                        <div>Charger Availability <b>{selSupport?.prevChargerAvailability ? 'Yes' : 'No'}</b></div>
                        <div>Charger Status <b>{selSupport?.prevChargerStatus}</b></div>
                        <div>Requested for refund <b>{<Badge size='small' count={selSupport?.refundNeeded ? 'Yes' : 'No'} color={selSupport?.refundNeeded ? '#2073f4' : '#909db0'} />}</b></div>
                        <div>Location <b>{selSupport?.previousCharger?.location?.locationName}</b></div>
                        <div>Priority <b>{selSupport?.priority}</b></div>
                        <div>Status <b>{selSupport?.status}</b></div>
                        <div>Total Cost <b>${(selSupport?.prevBooking?.totalCost ? selSupport?.prevBooking?.totalCost : selSupport?.prevBooking?.estimateAmount)?.toFixed(2)}</b></div>


                    </div>

                    <div className={styles['input-container']}>
                        <h5 className='mt-3 mb-3'>Update Support</h5>
                        <Form layout="vertical">

                            {(!selSupport?.refundStatus && !isAnyTicketRefunded) ?

                                <div className={styles['refund']}>

                                    <Checkbox checked={updateIssueForm?.refund} onChange={(e) => handleUpdateIssueFormChange('refund', e.target.checked)}>Release Locked Amount</Checkbox>

                                    {updateIssueForm.refund &&
                                        <>
                                            {!(selSupport?.prevBooking?.bookingStatus === 'Upcoming') ?
                                                <Form.Item className='ms-1' label={'Enter the refund amount'} required>

                                                    <InputNumber
                                                        placeholder="Amount"
                                                        style={{ width: '100%' }}
                                                        onChange={val => handleUpdateIssueFormChange('refundAmount', val)}
                                                        value={updateIssueForm?.refundAmount}
                                                    />

                                                </Form.Item>
                                                :
                                                <div className='mt-3'>
                                                    <div>
                                                        <FaCheck />
                                                        <span className='ms-1'>Estimated Refund Amount: <b>${updateIssueForm?.refundAmount}</b></span>
                                                    </div>
                                                    <div>
                                                        <FaCheck />
                                                        <span className='ms-1'>The refund process is scheduled for completion.</span>
                                                    </div>
                                                </div>

                                            }
                                        </>
                                    }

                                </div>

                                :
                                <div className={styles['refund']}>
                                    <div className='mt-1'>
                                        <div>
                                            <FaCheck />
                                            {(!isAnyTicketRefunded || isAnyTicketRefunded?._id === selSupport?._id)
                                                ?
                                                <><span className='ms-1'></span>Locked Amount Released: <b>${selSupport?.refundAmount?.toFixed(2)}</b></>
                                                :
                                                <><span className='ms-1'></span>Locked Amount on another ticket: <b>${isAnyTicketRefunded?.refundAmount?.toFixed(2)}</b></>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }

                            <Form.Item label={'Change Status'} required>
                                <Select
                                    placeholder="Select a Status"
                                    style={{ width: '100%' }}
                                    onChange={val => handleUpdateIssueFormChange('status', val)}
                                    value={updateIssueForm?.status}
                                    options={
                                        [
                                            { value: 'open', label: 'Open' },
                                            { value: 'closed', label: 'Closed' },
                                            { value: 'rejected', label: 'Rejected' },
                                        ]
                                    }
                                />
                            </Form.Item>
                            <Form.Item label= {'Update user via email'}>
                                <Select
                                placeholder="Yes/No"
                                value={sendEmailToUser}
                                onChange={val => setSendEmailToUser(val)}
                                    options={
                                        [
                                            { value: true, label: 'Yes' },
                                            { value: false, label: "No" }
                                        ]
                                    }
                                />
                            </Form.Item>

                            {selSupport?.image ?
                                <Form.Item label={'Image verification status'}>
                                    <Switch checkedChildren="Image Verified"
                                        unCheckedChildren="Image not verified"
                                        defaultChecked
                                        onChange={val => handleUpdateIssueFormChange('imageVerified', val)}
                                        value={updateIssueForm?.imageVerified}
                                    />
                                    <Button onClick={updateSupport} loading={submitting} className='float-end' type="primary">Update</Button>
                                </Form.Item>
                                :
                                <Button onClick={updateSupport} loading={submitting} type="primary">Update</Button>
                            }


                        </Form>
                    </div>
                </>

        },
        selSupport?.userID && {
            key: '2',
            label: 'User',
            children:
                <div className={styles['view-top']}>
                    <div>User <b>{selSupport?.userID?.firstName} {selSupport?.userID?.lastName}</b> {selSupport?.userID?.isGuest && <Tag color="gold">Guest</Tag>}</div>
                    <div>Email <b>{selSupport?.userID?.email}</b></div>
                    <div>Phone <b>{selSupport?.userID?.phone}</b></div>
                    <div>Wallet <b>${selSupport?.userID?.wallet?.coins?.toFixed(2)}</b></div>
                </div>

        },
        selSupport?.prevBooking && {
            key: '3',
            label: 'Booking',
            children:
                <div className={styles['view-top']}>
                    <div>Booking ID <b>{selSupport?.prevBooking?._id}</b></div>
                    <div>Booking Ended <b>{selSupport?.prevBooking?.bookingEnded ? 'Yes' : 'No'}</b></div>
                    <div>Booking Status <b>{selSupport?.prevBooking?.bookingStatus}</b></div>
                    <div>Booking Type <b>{selSupport?.prevBooking?.bookingType}</b></div>
                    <div>Charger Rebooted <b>{selSupport?.prevBooking?.chargerRebooted ? 'Yes' : 'No'}</b></div>
                    <div>Created At <b>{formatDate(selSupport?.prevBooking?.createdAt)}</b></div>
                    <div>Start Time <b>{formatDate(selSupport?.prevBooking?.startTime)}</b></div>
                    <div>End Time <b>{formatDate(selSupport?.prevBooking?.endTime)}</b></div>
                    <div>Total Free ConsumedEnergy <b>{selSupport?.prevBooking?.totalFreeConsumedEnergy?.toFixed(4)}</b></div>
                    <div>Total Paid ConsumedEnergy <b>{selSupport?.prevBooking?.totalPaidConsumedEnergy?.toFixed(4)}</b></div>
                    <div>Unutilized Time Fee <b>${selSupport?.prevBooking?.unUtilizedFee?.toFixed(2)}</b></div>
                    <div>Total Cost <b>${selSupport?.prevBooking?.totalCost?.toFixed(2)}</b></div>
                </div>
        },
        selSupport?.previousCharger && {
            key: '4',
            label: 'Charger',
            children:
                <>
                    <div className={styles['view-top']}>
                        <div>Charger ID <b>{selSupport?.previousCharger?._id}</b></div>
                        <div>Name <b>{selSupport?.previousCharger?.chargerTag}</b></div>
                        <div>Protocol <b>{selSupport?.previousCharger?.protocol}</b></div>
                        <div>Charger Status <b>{selSupport?.previousCharger?.chargerStatus}</b></div>
                        <div>Charger Available <b>{selSupport?.previousCharger?.chargerAvailability ? 'Yes' : 'No'}</b></div>
                        <div>Charger Unlisted <b>{selSupport?.previousCharger?.unlistCharger ? 'Yes' : 'No'}</b></div>
                    </div>

                    <div className={`${styles['view-top']} mt-2`}>
                        <div>Location ID <b>{selSupport?.previousCharger?.location?._id}</b></div>
                        <div>Location <b>{selSupport?.previousCharger?.location?.locationName}</b></div>
                        <div>Location Type <b>{selSupport?.previousCharger?.location?.locationType}</b></div>
                        <div>CodeId <b>{selSupport?.previousCharger?.location?.codeId}</b></div>
                        <div>Timezone <b>{selSupport?.previousCharger?.location?.timezone}</b></div>
                    </div>
                </>

        },
        selSupport?.newBooking && {
            key: '5',
            label: 'New Booking',
            children:
                <div className={styles['view-top']}>
                    <div>Booking ID <b>{selSupport?.newBooking?._id}</b></div>
                    <div>Booking Ended <b>{selSupport?.newBooking?.bookingEnded ? 'Yes' : 'No'}</b></div>
                    <div>Booking Status <b>{selSupport?.newBooking?.bookingStatus}</b></div>
                    <div>Booking Type <b>{selSupport?.newBooking?.bookingType}</b></div>
                    <div>Charger Rebooted <b>{selSupport?.newBooking?.chargerRebooted ? 'Yes' : 'No'}</b></div>
                    <div>Created At <b>{formatDate(selSupport?.newBooking?.createdAt)}</b></div>
                    <div>Start Time <b>{formatDate(selSupport?.newBooking?.startTime)}</b></div>
                    <div>End Time <b>{formatDate(selSupport?.newBooking?.endTime)}</b></div>
                    <div>Total Free ConsumedEnergy <b>{selSupport?.newBooking?.totalFreeConsumedEnergy?.toFixed(4)}</b></div>
                    <div>Total Paid ConsumedEnergy <b>{selSupport?.newBooking?.totalPaidConsumedEnergy?.toFixed(4)}</b></div>
                    <div>Unutilized Time Fee <b>${selSupport?.newBooking?.unUtilizedFee?.toFixed(2)}</b></div>
                    <div>Total Cost <b>${selSupport?.newBooking?.totalCost?.toFixed(2)}</b></div>
                </div>
        },
        selSupport?.newCharger && {
            key: '6',
            label: 'New Charger',
            children:
                <>
                    <div className={styles['view-top']}>
                        <div>Charger ID <b>{selSupport?.newCharger?._id}</b></div>
                        <div>Name <b>{selSupport?.newCharger?.chargerTag}</b></div>
                        <div>Protocol <b>{selSupport?.newCharger?.protocol}</b></div>
                        <div>Charger Status <b>{selSupport?.newCharger?.chargerStatus}</b></div>
                        <div>Charger Available <b>{selSupport?.newCharger?.chargerAvailability ? 'Yes' : 'No'}</b></div>
                        <div>Charger Unlisted <b>{selSupport?.newCharger?.unlistCharger ? 'Yes' : 'No'}</b></div>
                    </div>

                    <div className={`${styles['view-top']} mt-2`}>
                        <div>Location ID <b>{selSupport?.newCharger?.location?._id}</b></div>
                        <div>Location <b>{selSupport?.newCharger?.location?.locationName}</b></div>
                        <div>Location Type <b>{selSupport?.newCharger?.location?.locationType}</b></div>
                        <div>CodeId <b>{selSupport?.newCharger?.location?.codeId}</b></div>
                        <div>Timezone <b>{selSupport?.newCharger?.location?.timezone}</b></div>
                    </div>
                </>

        },
        {
            key: '7',
            label: 'Logs',
            children:
                <div>
                    {treeData.length === 0 ? <div className={styles['no-logs-found']}>No logs found</div> : null}
                    <Tree
                        treeData={treeData}
                        showLine
                    />
                </div>
        },
    ];


    return (
        <Modal
            title="View Support"

            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? '100%' : '50%'}
        >
            {!isLoading ?
                <ConfigProvider theme={{
                    token: {
                        colorPrimary: '#18365E',
                        colorBgContainer: '#fff',
                        boxShadow: 'none'
                    },
                }}>
                    <div className={styles['top-selection']}>
                        <Radio.Group value={selSupportBtnInput ? selSupportBtnInput : selSupportInput?._id} onChange={(e) => setSelSupportBtnInput(e.target.value)}>
                            {supportTicketFromSameBooking?.map((option, key) => (
                                <Tooltip placement="top" title={<>{option._id} <br />Status: {option.status}</>} >
                                    <Radio.Button type="link" key={option._id} value={option._id}>
                                        {key + 1}
                                        {/* status refundStatus refundAmount */}
                                    </Radio.Button>
                                </Tooltip>
                            ))}
                        </Radio.Group>
                    </div>
                    <Tabs defaultActiveKey="1" items={items} tabPosition='top' />
                </ConfigProvider>
                :
                <div>Loading...</div>
            }
        </Modal>
    );
};

export default ViewSupport;
